
















import { Component, Vue } from "vue-property-decorator";
import { ROOM_ONE, RoomData, RoomVariables } from "@/graphql/query/room/one";
import AuthTab, { AuthTabItem } from "@/containers/AuthTab.vue";
import NoData from "@/basics/boxes/NoData.vue";
import { USER_ME, UserMeData } from "@/graphql/query/user/me";

@Component({
  components: {
    AuthTab,
    NoData
  },
  apollo: {
    room: {
      query: ROOM_ONE,
      variables(): RoomVariables {
        const params = this.$apollo.vm.$route.params;
        return {
          roomId: params.roomId as string
        };
      }
    },
    groupId: {
      query: USER_ME,
      update(data: UserMeData): string {
        return data.me.group.id;
      }
    }
  }
})
export default class TabFrame extends Vue {
  room: RoomData | null = null;
  groupId: string = "";

  get isMyGroup() {
    // 所属と建物のグループが同じならtrue
    return !!(this.groupId! === this.room!.group.id);
  }

  get tabItems(): AuthTabItem[] {
    if (this.$apollo.loading || !this.room) {
      return [
        {
          name: "room-details",
          title: "機器情報",
          scopes: []
        },
        {
          name: "room-key",
          title: "カギ発行",
          scopes: []
        },
        {
          name: "room-status",
          title: "空室・入居モード切り替え",
          scopes: []
        },
        {
          name: "room-remote",
          title: "リモート解施錠",
          scopes: []
        },
        {
          name: "room-log",
          title: "操作履歴",
          scopes: []
        },
        {
          name: "room-edit",
          title: "編集",
          scopes: []
        }
      ];
    }

    const operation = [
      {
        resource: "Group",
        resourceId: this.room.group.id,
        action: "operation"
      }
    ];

    const seniorOperation = [
      {
        resource: "Group",
        resourceId: this.room.group.id,
        action: "senior_operation"
      }
    ];

    const management = [
      {
        resource: "Group",
        resourceId: this.room.group.id,
        action: "management"
      }
    ];

    return [
      {
        name: "room-details",
        title: "機器情報",
        scopes: operation
      },
      {
        name: "room-key",
        title: "カギ発行",
        scopes: operation
      },
      {
        name: "room-status",
        title: "空室・入居モード切り替え",
        scopes: seniorOperation
      },
      {
        name: "room-remote",
        title: "リモート解施錠",
        scopes: operation
      },
      {
        name: "room-log",
        title: "操作履歴",
        scopes: operation
      },
      {
        name: "room-edit",
        title: "編集",
        scopes: management
      }
    ];
  }
}
